/*globals $, window, document, checkMobile */

// Custom functionality for links
// Current types: anchor, tag

var LINK = {

    attr: "custom-link",

    // Via https://css-tricks.com/snippets/jquery/smooth-scrolling/
    scroll: function (event, offset, scrollSpeed) {
        "use strict";

        var target,
            scrollPos;

        if (!scrollSpeed) {
            scrollSpeed = 1000;
        }

        if (!offset) {
            offset = 0;
        }

        if (location.pathname.replace(/^\//, '') === event.pathname.replace(/^\//, '') || location.hostname === event.hostname) {
            $(event).blur();

            target = $(event.hash);
            target = target.length ? target : $('[name=' + event.hash.slice(1) + ']');
            scrollPos = target.data("anchor-dest") === "top" ? 0 : target.offset().top;
            scrollPos -= offset;
            
            target.removeAttr("id");
            window.location.hash = event.hash;
            target.attr("id", event.hash.substring(1));
            $(event).parent().addClass("active");
            $(event).parent().siblings().removeClass("active");

            if (target.length && $(document).scrollTop() !== scrollPos) {
                $("html, body").animate({
                    scrollTop: scrollPos
                }, scrollSpeed, function () {
                    // Functionality after scroll
                });

                return false;
            }
        }
    },

    tab: function (event, showAll) {
        "use strict";

        var eTarget     = $(event),
            linkTarget  = this.getTarget(eTarget),
            tabSiblings = eTarget.parent().siblings(),
            tabItem,
            tabTarget;

        $.each(tabSiblings, function () {
            tabItem = $(this);
            tabTarget = LINK.getTarget(tabItem.find("a"));

            tabItem.removeClass("active");
            $(tabTarget).next().removeClass("single");

            if (!showAll) {
                $(tabTarget).addClass("hide");
                $(tabTarget).next().addClass("hide");
            }
        });
        eTarget.parent().addClass("active");

        $(linkTarget).removeClass("hide");
        $(linkTarget).next().removeClass("hide");

        if (!showAll) {
            $(linkTarget).next().addClass("single");
        }

        // Close accordions, if they are present
        setTimeout(function () {
            resetAccordions();
        }, 500);
    },

    getTarget: function (link) {
        "use strict";

        return link.attr("href");
    },

    /**
     * Runs certain events depending on URL
     * Either checks the url PARAMETER "link" (e.g. ?link=test), which should be utilized if need multiple values; OR
     * Check the url HASH (e.g. #test)
     */
    runClickEvent: function () {
        "use strict";

        var parameter = getURLParameter("link") || location.hash.substr(1);
        
        if (parameter === "") {
            return;
        }

        $.each($("[data-" + LINK.attr + "]"), function () {
            var linkEle = $(this);

            switch (linkEle.data(LINK.attr)) {
            case "check":
                if (linkEle.attr("name") !== parameter) {
                    linkEle[0].checked = false;
                } else {
                    linkEle[0].checked = true;

                    $.each(linkEle.parents(), function(key, value) {
                        if ($(value).hasClass(linkEle.attr("name") + "-filter") && typeof toggleCheckboxDropdown === "function") {
                            toggleCheckboxDropdown($(value), true);
                        }
                    });
                    
                    if (getURLParameter("sublink")) {
                        $("[name=\"" + getURLParameter("sublink") + "\"]").attr("checked", "").parent().addClass("checked");
                        $("[name=\"store-item_use_all\"]").removeAttr("checked");
                    }
                        
                    if (getURLParameter("city")) {
                        $("#storeLocator").find("[data-search-ele=\"input\"]").val(getURLParameter("city"));
                        setTimeout(function () {
                            $("[data-gml-search=\"results\"]").click();
                        }, 500);
                        break;
                    }
                }
                break;
            default:
                if (linkEle.attr("href").substr(1) === parameter) {
                    $(this).click();
                }
                break;
            }
        });
    },

    toggleBrickElements: function (target) {
        "use strict";

        var tgtGrid = [
                "fan-photos",
                "gifs",
                "how-to-videos",
                "just-for-fun"
            ],
            splitTgt = target.href.split("#"),
            curTgt = splitTgt[splitTgt.length - 1];

        FEED.clearGrid();
        FEED.setGrid(tgtGrid.indexOf(curTgt));
//        $(".grid-item").addClass("hide");
//        $("." + tgtGrid[curTgt]).removeClass("hide");
        $(target).parent().siblings().removeClass("active");
        $(target).parent().addClass("active");
        
    }
};

document.addEventListener("gml_on_search_ready", function (e) {
    "use strict";

    LINK.runClickEvent();
});

document.addEventListener("wps_after_search_results", function (e) {
    "use strict";

    LINK.runClickEvent();
});

document.addEventListener("sf_after_embed_loaded", function (e) {
    "use strict";

    LINK.runClickEvent();
});

$(document).ready(function () {
    "use strict";

    checkMobile();

    // Custom anchor links
    $("body").click("data-" + LINK.attr, function (e) {
        var target = e.target;

        if (target.hasAttribute(e.data)) {
            $("html, body").stop();
            
            switch ($(target).attr(e.data)) {
            case "check":
                break;
            case "brick":
                LINK.toggleBrickElements(target);
                break;
            case "tab":
                e.preventDefault();
                LINK.tab(e.target);
                $("body").trigger("ontabchange");
            case "anchor":
            default:
                e.preventDefault();
                LINK.scroll(e.target);
                break;
            }
        }
    });
    
    $("#restaurantFilter, #retailFilter")
        .on("show.bs.collapse", function (e) {
            var checkbox = $(this).siblings(".checkbox").find("input");
            checkbox[0].checked = true;
            checkbox.parent().addClass("checked");
//        })
//        .on("hide.bs.collapse", function (e) {
//            var checkbox = $(this).siblings(".checkbox").find("input");
//            checkbox.removeAttr("checked");
//            checkbox.parent().removeClass("checked");
        });
});

$(window).load(function () {
    "use strict";

    LINK.runClickEvent();
});